/* unplugin-vue-components disabled */import script from "./ArticleRight.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleRight.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleRight.vue?vue&type=style&index=0&id=4691c5bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4691c5bc"]])

export default __exports__